import PageWrapper from '../components/basic/PageWrapper';
import HeroSection from '../components/components/TrackingPage/HeroSection';
import TrackingForm from '../components/components/TrackingPage/TrackingForm';
import TrackingPageHelmet from '../components/components/TrackingPage/TrackingPageHelmet';
const TrackingPage = () => {
  return (
    <PageWrapper>
      <TrackingPageHelmet />
      <HeroSection />
      <TrackingForm />
    </PageWrapper>
  );
};

export default TrackingPage;
